// Override Settings
var boostPFSInstantSearchConfig = {
  search: {
    //suggestionMode: 'test',
    //suggestionPosition: 'left'
    //suggestionMobileStyle: 'style2'
  }
};

(function () {
  /* This is to inject boost components into this scope, so we can override component's function */
  BoostPFS.inject(this);

  // Customize style of Suggestion box
  SearchInput.prototype.customizeInstantSearch = function() {};

   /* Start-Boost-Fix-Price */
  InstantSearchResult.prototype.render = function() {
		if (this.isFirstLoad) {
			// Render initial suggestion container and append it to the dom
			var suggestionHtml = this.compileTemplate();
			this.appendToSelector = 'body';
			this._applyFilterAutocompleteAppendElement();

			jQ(this.appendToSelector).append(suggestionHtml);
			this.$wrapper = jQ(this.selector.wrapper);
			this.$popoverElement = jQ(this.selector.popover);
			this.isFirstLoad = false;
		} else {
			// Show the suggestion popover and suggestion itself
			this.$instantSearchResult.show();
			this.$instantSearchResult.siblings().show();
			// Render suggestion blocks and items
			if (this.isLoading) {
				this._renderSuggestionLoading();
				this._renderWrapper();
			} else {
				this._renderWrapper();
				this._renderSuggestion();
			}

		}

        if(typeof(this.data) !== 'undefined' && this.data !== null && this.data.length > 0){
          var searchProducts = [];
          for(var i = 0; i < this.data.length; i++){
            if(this.data[i].key == 'products'){
              searchProducts = this.data[i].values;
              break;
            }
          }
          if(searchProducts.length > 0){
            for(var i = 0; i < searchProducts.length; i++){
              var requestReg = formRequest(searchProducts[i].handle);
              requestReg.then((res_success) => {
                var res = JSON.parse(res_success);
                jQ('.boost-pfs-search-suggestion-item[data-id="'+ res.id +'"]').find('.boost-pfs-search-suggestion-product-price').html(res.price);
              }).catch((res_error) => {
                console.log(res_error)
              });
            }
          }
        }
	}

  function formRequest(value) {
    return new Promise((resolve, reject) => {
        var xhr = window.XMLHttpRequest ? new XMLHttpRequest() : new ActiveXObject('Microsoft.XMLHTTP');
        xhr.open("GET", Shopify.routes.root + 'products/'+ value +'?view=boost-pfs-integration');
        xhr.setRequestHeader('Content-Type', 'application/json');
        xhr.onload = () => resolve(xhr.responseText);
        xhr.onerror = () => reject(xhr.statusText);
        xhr.send();
    });
  }
  InstantSearchApi.beforeCall = function(searchTerm) {
      Globals.instantSearchQueryParams.currency = boostPFSConfig.general.current_currency.toLowerCase();
      Globals.instantSearchQueryParams.currency_rate = Shopify.currency.rate;
      Globals.instantSearchQueryParams.return_all_currency_fields = false;
  }
  /* End-Boost-Fix-Price */
  
})();